import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./homeservice.css";

const ServicesSection = () => {
  const navigate = useNavigate();

  const servicesData = [
    {
      id: 1,
      title: "FULL KUNDLI ANALYSIS",
      image: "/assets/new kundli.png",
      description: [
        "Covers career, love, health, finance, friends, etc.",
        "Know what’s next in your life & upcoming phases",
        "Understand your strengths, purpose & hidden patterns",
        "Get accurate remedies and future guidance",
        "In this session, you can ask anything unlimited questions within your time slot",
        "Every answer. Every detail. One session"
      ],
      basePrice: 770,
      key: "kundlianalysis",
    },
    {
      id: 2,
      title: "RELATIONSHIP & MARRIAGE CONSULTATION",
      image: "/assets/relationshio.png",
      description: [
        "Decode your love life, emotions & relationship patterns",
        "Know why connections fade or marriage feels delayed",
        "Find when & with whom stability and true love will align",
        "Get personalized remedies & guidance for harmony in relationships",
        "Unlimited questions related to love & marriage within your allotted time",
        "A session where ✨ Where every heart finds its answers",
      ],
      basePrice: 560,
      key: "lovelifeconsultation",
    },
    {
      id: 3,
      title: "CAREER GUIDANCE",
      image: "/assets/carreer.png",
      description: [
        "Understand your career path, strengths & true potential",
        "Find when and where success will finally open up for you",
        "Know if you should continue, switch, or start something new",
        "Get remedies & timing insights for growth and stability",
        "Unlimited questions related to career & profession within your opted time",
        "A session where Your next big move starts with the right guidance."
      ],
      basePrice: 560,
      key: "careerconsultation",
    },
    {
      id: 4,
      title: "QUICK CONSULTATION (10 MIN)",
      image: "/assets/time.png",
      description: [
        "Perfect for those who want quick clarity without heavy cost",
        "Ask as many questions as you can within 10 minutes",
        "Get instant, practical insights from your birth chart",
        "Straightforward guidance — no fluff, only real answers",
        "Ideal for quick decisions, urgent doubts, or instant direction",
        "A session where you can find clarity in just 10 minutes",
      ],
      basePrice: 350,
      key: "Quickconsultation",
    },
  ];

  const [cardStates, setCardStates] = useState(
    servicesData.map(() => ({ mode: "Normal", duration: "30 Min" }))
  );

  const handleToggle = (index, type, value) => {
    const updated = [...cardStates];
    updated[index][type] = value;
    setCardStates(updated);
  };

  const calculatePrice = (card, index) => {
    const { mode, duration } = cardStates[index];
    const base = card.basePrice;

    if (mode === "Normal" && duration === "30 Min") return base;
    if (mode === "Normal" && duration === "1 Hour") return base * 2;
    if (mode === "Urgent" && duration === "30 Min") return base * 1.6;
    if (mode === "Urgent" && duration === "1 Hour") return base * 2.5;
  };

  const handleBookNow = (service, index) => {
    const { mode, duration } = cardStates[index];
    navigate("/Book-your-slot", {
      state: {
        selectedService: service.key,
        mode,
        duration,
      },
    });
  };

  return (
    <section className="services-section">
      <div className="services-header">
        <h4 className="services-subtitle">SERVICES</h4>
        <h2 className="services-title">
          Choose what you want to understand today and let the universe guide the rest.
        </h2>
      </div>

      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div key={service.id} className="service-card">
            <div className="service-img">
              <img src={service.image} alt={service.title} />
            </div>

            <h3 className="service-title">{service.title}</h3>

            <ul className="service-text">
              {service.description.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <div className="consult-options">
              {/* Mode Selection */}
              <div className="option-group">
                <h4>Mode:</h4>
                <div className="toggle-btn">
                  <span
                    className={`toggle-option ${cardStates[index].mode === "Normal" ? "active" : ""}`}
                    onClick={() => handleToggle(index, "mode", "Normal")}
                  >
                    Normal
                  </span>
                  <span
                    className={`toggle-option ${cardStates[index].mode === "Urgent" ? "active" : ""}`}
                    onClick={() => handleToggle(index, "mode", "Urgent")}
                  >
                    Urgent
                  </span>
                </div>
              </div>

              {/* Duration Selection */}
              {service.title !== "QUICK CONSULTATION (10 MIN)" && (
                <div className="option-group">
                  <h4>Duration:</h4>
                  <div className="toggle-btn">
                    <span
                      className={`toggle-option ${cardStates[index].duration === "30 Min" ? "active" : ""}`}
                      onClick={() => handleToggle(index, "duration", "30 Min")}
                    >
                      30 Min
                    </span>
                    <span
                      className={`toggle-option ${cardStates[index].duration === "1 Hour" ? "active" : ""}`}
                      onClick={() => handleToggle(index, "duration", "1 Hour")}
                    >
                      1 Hour
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className="consult-footer">
              <div className="price">
                <p>Price</p>
                <h3>₹{calculatePrice(service, index).toLocaleString("en-IN")}</h3>
              </div>
              <button
                className="hero-button-homeherosectioncc"
                onClick={() => handleBookNow(service, index)}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
